import { render } from "./SponsersForm.vue?vue&type=template&id=5994b3ae"
import script from "./SponsersForm.vue?vue&type=script&lang=js"
export * from "./SponsersForm.vue?vue&type=script&lang=js"

import "./SponsersForm.vue?vue&type=style&index=0&id=5994b3ae&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__